module.exports = __webpack_public_path__ + "img/Value.86e03596.png";